import {
  createRouter,
  createWebHistory
} from 'vue-router'
import Home from '../views/Home.vue'

const routes = [{
    path: '/',
    component: Home
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/picture',
    name: 'Picture',
    component: () => import( /* webpackChunkName: "about" */ '../views/Picture.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/committee',
    name: 'Committee',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ '../views/personnel.vue')
  },
  {
    path: '/activity',
    name: 'ACTIVITY',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ '../views/activity.vue')
  },
  {
    path: '/contactus',
    name: 'CONTACTUS',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ '../views/contactus.vue')
  },
  {
    path: '/information',
    name: 'INFORMATION',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ '../views/information.vue')
  },
  {
    path: '/information/:id',
    name: 'INFORMATIONDETAIL',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ '../views/informationdetail.vue')
  }, {
    path: '/joinus',
    name: 'JOINUS',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ '../views/joinus.vue')
  },
  {
    path: '/membership',
    name: 'MEMBERSHIP',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ '../views/membership.vue')
  }, {
    path: '/upload',
    name: 'UPLOAD',
    component: () => import( /* webpackChunkName: "about" */ '../views/upload.vue')
  },
  {
    path: '/Registration',
    name: 'Registration',
    component: () => import( /* webpackChunkName: "about" */ '../views/Registration.vue')

  },
  {
    path: '/writeoff',
    name: 'writeoff',
    component: () => import( /* webpackChunkName: "about" */ '../views/writeoff.vue')

  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    console.log(to, from, savedPosition);
    return {
      top: 0
    };
  },
})

export default router